import React, { useEffect, useRef } from "react";
import * as Styled from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import UserImage from "../../../UserImage";
import { TextView } from "@components";
import { useState } from "react";
import { ASSETS } from "../../../../utils/config";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircularProgress from "@mui/material/CircularProgress";
import { useGetWheelAuthors } from "../../../../services/queries";

export default function WheelAuthor({ style, wheelId,onClose }) {
  const [viewAll, setViewAll] = useState(false);
  const ref = useRef(null);

  const { data = {}, isLoading } = useGetWheelAuthors(wheelId);

  const original_author = data?.data?.extra?.original_auther;
  const cloned_from = data?.data?.extra?.cloned_from;
  const results = data?.data?.results || [];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose()
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);


  return (
       <Styled.AuthorInfo ref={ref} style={style}>
          <Styled.AuthorHeader>
            <Styled.LeftView>
              <Styled.ImageView>
                <img src={ASSETS.segmentEditor.BookIcon} style={{ width: 20, height: 17 }} />
              </Styled.ImageView>
              <TextView variant="subtitle">Wheel Author</TextView>
            </Styled.LeftView>

            <CloseIcon
              onClick={onClose}
              style={{ cursor: "pointer" }}
            />
          </Styled.AuthorHeader>
          {isLoading ? (
            <Styled.Loader>
              <CircularProgress size={20} />
            </Styled.Loader>
          ) : (
            <>
              <Styled.AuthorView>
                <UserImage image={original_author?.profile_image} />
                <div style={{ marginLeft: 10 }}>
                  <TextView variant="subtitle">
                    {original_author?.first_name} {original_author?.last_name}
                  </TextView>
                  <TextView>Original Author</TextView>
                </div>
              </Styled.AuthorView>
              {!!results.length && (
                <Styled.OtherAuthors>
                  <Styled.Header>
                    <TextView>View other authors</TextView>
                    {viewAll ? (
                      <ExpandMoreIcon
                        onClick={() => setViewAll(false)}
                        style={{ cursor: "pointer" }}
                      />
                    ) : (
                      <ChevronRightIcon
                        onClick={() => setViewAll(true)}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </Styled.Header>
                  {viewAll && (
                    <Styled.OtherAuthorView>
                      {results.map((user, index) => {
                        if (index !== 0) {
                          return (
                            <>
                              <Styled.Separator />
                              <Styled.OtherAuthorItem>
                                <UserImage
                                  size={24}
                                  image={user?.profile_image}
                                />
                                <TextView style={{ marginLeft: 6 }}>
                                  {user?.first_name} {user?.last_name}
                                </TextView>
                              </Styled.OtherAuthorItem>
                            </>
                          );
                        } else {
                          return (
                            <Styled.OtherAuthorItem>
                              <UserImage
                                size={24}
                                image={user?.profile_image}
                              />
                              <TextView style={{ marginLeft: 6 }}>
                                {user?.first_name} {user?.last_name}
                              </TextView>
                            </Styled.OtherAuthorItem>
                          );
                        }
                      })}
                    </Styled.OtherAuthorView>
                  )}
                </Styled.OtherAuthors>
              )}
              {cloned_from ? (
                <Styled.ClonedFrom>
                  <UserImage image={cloned_from?.profile_image} size={34} />
                  <div style={{ marginLeft: 10 }}>
                    <TextView>Cloned from</TextView>
                    <TextView variant="subtitle">
                      {cloned_from?.first_name} {cloned_from?.last_name}
                    </TextView>
                  </div>
                </Styled.ClonedFrom>
              ) : null}
            </>
          )}
        </Styled.AuthorInfo>

  );
}
